// Added JavaScript proceeding theme.js (that doesn't require any liquid or any vars from the .js.liquid theme file)
// Runs on every theme page. Allows for easier editing/highlighting when can be pure JS
$(window).scroll(function() {
  var s = $(".ld-body");
  var pos = s.position();

  if (s.length) {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top & windowpos <=0) {
      s.removeClass("ld-body--scrolled");
    } else {
      s.addClass("ld-body--scrolled");
    }
  }
});
$(window).scroll(function() {
  $(".ld-body").removeClass("ld-body--bottom");
  if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100) ) {
    // At bottom
    $(".ld-body").addClass("ld-body--bottom");
  }
});
$(function () {
  // Back to top button
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".ld-body").offset().top
    }, 800);
    e.preventDefault();
  });

  // Bind smooth scrolling to anchors
  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 600, 'linear');
  });

  // Draggy
  $('.js-ld-draggy').draggable();

  // Accordion toggle on product page
  $('body').on('click', '.ld-product-desc-toggle', function(e) {
    e.preventDefault();
    $(this).parents(".ld-product-desc-accordian").toggleClass("ld-product-desc-accordian--open");
  });
  //  Sizing chart toggle
  $('body').on('click', '.js-sizing-chart', function(e) {
    e.preventDefault();
    $(".ld-sizingchart-popup").toggleClass("ld-sizingchart-popup--open");
    $(".ld-body").toggleClass("ld-body--size-chart-open");
  });
  $('body').on('click', '.ld-archive-toggle', function(e) {
    e.preventDefault();
    $(this).toggleClass("ld-product-thumbnail-archive--open");
  });

  // Menu toggle
  $('body').on('click', '#mobile-menu-toggle', function(e) {
    e.preventDefault();
    $(".ld-mobile-menu-container").toggleClass("ld-mobile-menu-container--open");
    $(".ld-page").toggleClass("ld-page--mobile-menu-is-open");
    $(".ld-mobile-menu-secondary-nav--shop").removeClass("ld-mobile-menu-secondary-nav--open");
    $(".ld-mobile-menu-secondary-nav--editorial").removeClass("ld-mobile-menu-secondary-nav--open");
    $(".ld-mobile-menu-secondary-nav--about").removeClass("ld-mobile-menu-secondary-nav--open");
  });

  $('body').on('click', '.js-shop-menu-toggle', function(e) {
    e.preventDefault();
    $(".ld-mobile-menu-secondary-nav--shop").toggleClass("ld-mobile-menu-secondary-nav--open");
  });

  $('body').on('click', '.js-editorial-menu-toggle', function(e) {
    e.preventDefault();
    $(".ld-mobile-menu-secondary-nav--editorial").toggleClass("ld-mobile-menu-secondary-nav--open");
  });

  $('body').on('click', '.js-about-menu-toggle', function(e) {
    e.preventDefault();
    $(".ld-mobile-menu-secondary-nav--about").toggleClass("ld-mobile-menu-secondary-nav--open");
  });

  // Editorial image click-to-enlarge popup
  $('body').on('click', '.js-editorial-image-toggle', function(e) {
    e.preventDefault();
    $(this).addClass('ld-editorial-image--show');
    $(this).removeClass('js-editorial-image-toggle');
  });

  $('body').on('click', '.js-editorial-image-toggle-close', function(e) {
    e.preventDefault();
    $(this).parents('.feature-editorial-grid-image').removeClass('ld-editorial-image--show');
    $(this).parents('.feature-editorial-grid-image').addClass('js-editorial-image-toggle');
  });
});
